import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of, take } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (authService.isAuthenticated() && authService.user()) {
        return true;
    }

    // If we have a stored token, verify it first (page refresh scenario)
    const token = authService.getAccessToken();
    if (token) {
        return authService.verify().pipe(
            take(1),
            map(user => {
                if (user) return true;
                // On a genuine 401 the interceptor has already cleared the token, so no
                // token means a real auth failure — go to login. If a token still exists,
                // verify() failed at the transport level (aborted refresh, 304/truncated
                // response, 5xx, offline): don't log the user out, let them through and
                // let the 401 interceptor handle a truly bad token on the next API call.
                if (authService.getAccessToken()) return true;
                router.navigate(['/auth/login']);
                return false;
            }),
            catchError(() => {
                if (authService.getAccessToken()) return of(true);
                router.navigate(['/auth/login']);
                return of(false);
            })
        );
    }

    // No tokens, redirect to login
    router.navigate(['/auth/login']);
    return false;
};